var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"CaptureMap-container\">\n<div class=\"CaptureMap\"></div>\n<div class=\"CaptureMap-zoomControls\">\n<ike-zoom-control get-zoom=\"ctrl.getZoom()\" set-zoom=\"ctrl.setZoom(zoom)\" on-zoomin-click=\"ctrl.zoomIn()\" on-zoomout-click=\"ctrl.zoomOut()\" min=\"3\" max=\"18\">\n</ike-zoom-control>\n<a class=\"CaptureMap-zoomFit\" ng-click=\"ctrl.zoomFit()\"></a>\n</div>\n</div>";
var id1="capture.map.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/map/capture/capture.map.html
// module id = 584
// module chunks = 0